import React, { useEffect, useState, useCallback } from 'react';
import { Modal, Spinner } from 'react-bootstrap';

const Gallery = () => {
    const [selectedIndex, setSelectedIndex] = useState(null);
    const [images, setImages] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        fetch('/images-list.php')
            .then((res) => res.json())
            .then((data) => {
                if (!data.success) {
                    throw new Error(data.message || 'Galerii se nepodařilo načíst.');
                }
                setImages(data.images || []);
            })
            .catch(() => {
                setError('Galerii se nepodařilo načíst.');
            })
            .finally(() => setLoading(false));
    }, []);

    const isOpen = selectedIndex !== null;

    const showPrev = useCallback(() => {
        setSelectedIndex((i) => (i === null ? null : (i - 1 + images.length) % images.length));
    }, [images.length]);

    const showNext = useCallback(() => {
        setSelectedIndex((i) => (i === null ? null : (i + 1) % images.length));
    }, [images.length]);

    useEffect(() => {
        if (!isOpen) return;

        const handleKey = (e) => {
            if (e.key === 'ArrowLeft') showPrev();
            if (e.key === 'ArrowRight') showNext();
            if (e.key === 'Escape') setSelectedIndex(null);
        };

        window.addEventListener('keydown', handleKey);
        return () => window.removeEventListener('keydown', handleKey);
    }, [isOpen, showPrev, showNext]);

    return (
        <div className="container my-5">
            <h1 className="hk-page-title">
                <i className="bi bi-images me-2"></i>Galerie
            </h1>

            {loading && (
                <div className="text-center my-5">
                    <Spinner animation="border" role="status" />
                </div>
            )}

            {!loading && error && (
                <p className="text-center text-danger">{error}</p>
            )}

            {!loading && !error && images.length === 0 && (
                <p className="text-center">Zatím tu nejsou žádné fotky.</p>
            )}

            {!loading && !error && images.length > 0 && (
                <div className="row g-3">
                    {images.map((image, index) => (
                        <div className="col-6 col-md-4 col-lg-3" key={image.name}>
                            <div
                                className="gallery-image position-relative overflow-hidden"
                                onClick={() => setSelectedIndex(index)}
                            >
                                <img
                                    src={image.url}
                                    alt="Galerie"
                                    className="img-fluid"
                                    loading="lazy"
                                />
                            </div>
                        </div>
                    ))}
                </div>
            )}

            {/* Lightbox se šipkami pro procházení */}
            <Modal
                show={isOpen}
                onHide={() => setSelectedIndex(null)}
                size="xl"
                centered
                contentClassName="hk-lightbox-content"
            >
                <Modal.Body className="hk-lightbox-body text-center">
                    {isOpen && (
                        <>
                            <button
                                type="button"
                                className="hk-lightbox-close"
                                onClick={() => setSelectedIndex(null)}
                                aria-label="Zavřít"
                            >
                                <i className="bi bi-x-lg"></i>
                            </button>

                            {images.length > 1 && (
                                <button
                                    type="button"
                                    className="hk-lightbox-nav hk-lightbox-nav-prev"
                                    onClick={showPrev}
                                    aria-label="Předchozí"
                                >
                                    <i className="bi bi-chevron-left"></i>
                                </button>
                            )}

                            <img
                                src={images[selectedIndex].url}
                                alt="Zvětšeno"
                                className="hk-lightbox-img"
                            />

                            {images.length > 1 && (
                                <button
                                    type="button"
                                    className="hk-lightbox-nav hk-lightbox-nav-next"
                                    onClick={showNext}
                                    aria-label="Další"
                                >
                                    <i className="bi bi-chevron-right"></i>
                                </button>
                            )}

                            {images.length > 1 && (
                                <div className="hk-lightbox-counter">
                                    {selectedIndex + 1} / {images.length}
                                </div>
                            )}
                        </>
                    )}
                </Modal.Body>
            </Modal>
        </div>
    );
};

export default Gallery;
